module.exports = [{"id":"tx-001","coinID":"neo","symbol":"NEO","price":"0.002","amount":"120"},{"id":"tx-002","coinID":"neo","symbol":"NEO","price":"0.0025","amount":"150"},{"id":"tx-003","coinID":"dragonchain","symbol":"DRGN","price":"0.0025","amount":"150"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/portfolioCoins.json
// module id = 706
// module chunks = 0